export const APP_URL = process.env.REACT_APP_URL ?? 'stg.cloud.startup-kit.io'
export const API_URL = process.env.REACT_APP_API_URL ?? 'http://bff.sk-cloud.local'
export const CDN_URL = process.env.CDN_URL ?? 'https://d12yao1zzkok0.cloudfront.net'